import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ClientLogosSection from "./components/ClientLogosSection";
import AboutSection from "./components/AboutSection";
import StatsCounterSection from "./components/StatsCounterSection";
import ServicesSection from "./components/ServicesSection";
import CTABanner from "./components/CTABanner";
import IndustriesSection from "./components/IndustriesSection";
import WhyChooseSection from "./components/WhyChooseSection";
import ProcessSection from "./components/ProcessSection";
import BankingSection from "./components/BankingSection";
import TechnologiesSection from "./components/TechnologiesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import EmployeeTestimonialsSection from "./components/EmployeeTestimonialsSection";
import CareersSection from "./components/CareersSection";
import FAQSection from "./components/FAQSection";
import ContactSection from "./components/ContactSection";
import NewsletterSection from "./components/NewsletterSection";

export default function Home() {
  return (
    <main className="min-h-screen">
      <Navbar />
      <HeroSection />
      <ClientLogosSection />
      <AboutSection />
      <StatsCounterSection />
      <ServicesSection />
      <CTABanner />
      <IndustriesSection />
      <WhyChooseSection />
      <ProcessSection />
      <BankingSection />
      <TechnologiesSection />
      <TestimonialsSection />
      <EmployeeTestimonialsSection />
      <CareersSection />
      <FAQSection />
      <ContactSection />
      <NewsletterSection />
      <Footer />
    </main>
  );
}